<template>

  <div>

    <loading v-show="showLoading"></loading>

    <div v-show="!showLoading" class="mine-collection-back">

      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">

        <div class="mine-collection-bar">
          <div v-bind:class="[isAll==true?'mine-collection-bar-choice':'mine-collection-bar-noChoice']" @click="choiceType()">
            所有分类
          </div>
          <div v-bind:class="[isAll==false?'mine-collection-bar-choice':'mine-collection-bar-noChoice']" @click="choiceType()">
            仅看有货
          </div>
        </div>

        <div class="mine-collection-content" v-if="collectionList.length>0">
          <div class="mine-coll-goods">
            <div class="mine-coll-goods-each" v-for="(coll,index) in collectionList" :key="index" @click.stop="goDetail(coll.productId)" @touchstart.stop="gtouchstart(coll.productId)" @touchend="emptyTime">
                <div class="mine-coll-goods-left">
                  <van-image :src="coll.smallImageUrl" fit="cover">
                    <template v-slot:error></template>
                  </van-image>
                </div>
                <div class="mine-coll-goods-right">
                  <div class="mine-coll-goods-name">
                    {{coll.productName}}
                  </div>
                  <div class="mine-coll-goods-div-bottom">
                    <div class="mine-coll-goods-price" v-if="coll.isLapse == 1">
                      ¥{{coll.price}}
                    </div>
                    <div class="mine-collection-status" v-if="coll.isLapse == 0">
                      失效
                    </div>
                  </div>
                </div>

                <div class="mine-coll-shadow" v-if="coll.isShadow == true" @click.stop="hideShadow(coll.productId)">
                  <div class="mine-coll-content">
                    <!--<button>-->
                      <!--去分享-->
                    <!--</button>-->
                    <button @click.stope="cancelColl(coll.productId)">
                      删除
                    </button>
                  </div>
                </div>

              </div>
            <refresh  @zj-load="loadMore" :lastPage='{total: !allLoaded, empty: collectionList.length,show:show}'></refresh>
          </div>

        </div>

        <div class="mine-collection-noData" v-if="collectionList.length==0">
          您暂时没有收藏商品,赶快去选购吧
        </div>



      </van-pull-refresh>

    </div>

  </div>

</template>

<script>

  import Vue from 'vue'
  import { storeName,prodCatalogId,loginInfo, } from '@/router/Constant'
  import { login,getProductCollectList,updateProductCollectInfo} from '@/router/api'
  import { NavBar, Image, Grid, Tabbar, Toast,PullRefresh,Dialog,SwipeCell,Button,Cell} from 'vant'
  import loading from '@/components/page/common/loading.vue'
  import { setStore,getStore,getCookie,setCookie } from '@/utils/mUtil';
  import refresh from '@/components/page/common/refresh.vue';

  export default {
    name: "mineCollection",
    data(){
      return{
        showLoading:true,
        token:getStore('externalLoginKey'),
        viewIndex:0,
        viewSize:10,
        collectionList:[],
        show: false,
        allLoaded: false,
        isLoading:false,
        productStoreId:storeName,
        isAll:true,
        typeId:0,
        Loop:null
      }
    },
    mounted(){
      this.initData()
    },
    components:{
      [NavBar.name]: NavBar,
      [Image.name]: Image,
      [Grid.name]: Grid,
      [Tabbar.name]: Tabbar,
      [Toast.name]: Toast,
      [PullRefresh.name]: PullRefresh,
      loading,
      refresh,
      [Dialog.Component.name]: Dialog.Component,
      [SwipeCell.name]:SwipeCell,
      [Button.name]:Button,
      [Cell.name]:Cell
    },
    methods: {

      async initData() {
        if (getStore('islogIn') != 'true') {
          this.dialogAction('查看商品收藏需要登录，是否现在登录？');
        } else {
          this.getCollectionList()
        }
      },

      dialogAction(msg){
        Dialog.confirm({
          message: msg
        }).then(() => {
          if (getStore('fromType')=='mini') {
            wx.miniProgram.switchTab({url:'../../pages/menu/menu'})
          } else {
            wx.miniProgram.switchTab({url:'../../pages/menu/menu'})
          }
        }).catch(() => {

        });
      },


      //获取订单列表
      getCollectionList: function () {
        let params = {
          externalLoginKey: this.token,
          typeId:this.typeId,
          viewIndex: this.viewIndex,
          viewSize: this.viewSize
        }
        getProductCollectList(params)
          .then(res => {
            this.showLoading = false
            console.log(res);
            if (res._EVENT_MESSAGE) {
              // Toast(res._EVENT_MESSAGE)
            } else {
              if (res.resultMap.productCollectList) {

                if (this.viewIndex == 0) {
                  this.show = false
                } else {
                  this.show = true
                }

                if (res.resultMap.productCollectList.length < this.viewSize) {
                  this.allLoaded = true
                } else {
                  this.allLoaded = false
                }
                var oldProductList = this.collectionList
                var newProductList = oldProductList.concat(res.resultMap.productCollectList)
                this.collectionList = newProductList
                for(var i =  0;i<this.collectionList.length;i++){
                  this.collectionList[i].isShadow = false
                }
                this.viewIndex = res.resultMap.viewIndex;
              } else {
              }
            }
          })
          .catch(err => {
            this.showLoading = false
            console.log(err);
          });
      },

      //上拉加载
      loadMore() {
        if (!this.allLoaded) {
          this.viewIndex++;
          this.getCollectionList()
        }
      },

      //下拉刷新
      onRefresh() {
        setTimeout(() => {
          this.collectionList = []
          this.getCollectionList()
          this.isLoading = false
        }, 1000);
      },

      //选择获取的商品类型
      choiceType:function () {
        if(this.isAll==true){
          this.isAll=false
          this.typeId = 1
        }else{
          this.isAll=true
          this.typeId = 0
        }
        this.viewIndex = 0
        this.collectionList = []
        this.getCollectionList()
      },

      //跳转至商品详情
      goDetail:function (productId) {
        this.$router.push({name:'goodsDetail',query:{goodsId:productId}})
      },

      gtouchstart:function(productId){
        clearTimeout(this.Loop); //再次清空定时器，防止重复注册定时器
        this.Loop = setTimeout(function() {
          this.editColl(productId)
        }.bind(this), 1000);

      },

      //清空
      emptyTime:function () {
        clearTimeout(this.Loop); //清空定时器，防止重复注册定时器
      },

      //用户长按
      editColl:function (productId) {
        for(var i = 0;i<this.collectionList.length;i++){
          if(productId == this.collectionList[i].productId){
            this.collectionList[i].isShadow = true
          }
        }
        this.$forceUpdate();
      },

      //取消商品收藏
      cancelColl:function (productId) {
        let paramList = {
          externalLoginKey: this.token,
          productId: productId,
          productStoreId: this.productStoreId,
        }
        updateProductCollectInfo(paramList).then(res => {
          console.log(res)
          if(res._EVENT_MESSAGE){
            Toast({message:res._EVENT_MESSAGE})
            this.viewIndex  = 0
            this.collectionList = []
            this.getCollectionList()
          }else{
            Toast({message:res._EVENT_MESSAGE})
          }

        }).catch(err =>{
          console.log(err)
        })
      },

      //隐藏阴影层
      hideShadow:function (productId) {
        for(var i = 0;i<this.collectionList.length;i++){
          if(productId == this.collectionList[i].productId){
            this.collectionList[i].isShadow = false
          }
        }
        this.$forceUpdate();
      }


    }
  }
</script>

<style>
  .mine-collection-back{
    background-color: #F8F8F8;
  }

  .nav_bar {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    position: fixed;
    z-index: 99;
    width: 100%;
    background: white;
    opacity: 1;
    border-bottom: 1px solid #E1E1E1;
    display: block;
  }
  .nav_bar_left_item {
    padding-top: 0.3rem;
    width:3rem;
  }
  .nav_item_btn {
    width: 1.25rem;height: 1.25rem;
  }
  .coll-bar-title{
    width:calc(100% - 3rem);
    text-align: center;
    font-size: 1rem;
    color:#333312;
  }

  .mine-collection-bar{
    width:100%;
    /*padding-top: 3rem;*/
    margin-bottom: 0.625rem;
    background-color: white;
  }
  .mine-collection-bar div{
    width:4.375rem;
    height:1.5625rem;
    font-size: 0.8125rem;
    border-radius: 0.75rem;
    display: inline-block;
    vertical-align: top;
    text-align: center;
    line-height: 1.5625rem;
    margin-left: 1rem;
    margin-top: 0.9375rem;
    margin-bottom: 0.9375rem;
  }
  .mine-collection-bar-choice{
     color:#EB84AB;
     border: 1px solid #EB84AB;
   }
  .mine-collection-bar-noChoice{
    color:#666666;
    border: 0px;
  }


  .mine-collection-content{
    width:100%;
    background-color: white;
  }
  .mine-coll-goods{
    width:100%;
  }
  .mine-coll-goods-each{
    margin: 0 auto;
    border-bottom: 1px solid #e7e7e7;
    padding-bottom: 0.9375rem;
    padding-top: 0.9375rem;
    height: 4.9375rem;
  }
  .mine-coll-goods-left{
    display: inline-block;
    vertical-align: top;
    height: 5rem;
    margin-left: 1rem;
    margin-right:0.6875rem;
  }
  .mine-coll-goods-left .van-image{
    width:5rem;
    height: 5rem;
  }
  .mine-coll-goods-right{
    width:calc(100% - 8.5rem);
    display: inline-block;
    vertical-align: top;
    margin-right:1rem;
  }
  .mine-coll-goods-name{
    font-size: 0.875rem;
    color:#333;
    line-height: 1.25rem;
  }
  .mine-coll-goods-div-bottom{
    width:100%;
    height: 1.875rem;
    line-height: 1.875rem;
    margin-top: 2rem;
  }
  .mine-coll-goods-price{
    color:#EB84AB;
    font-size: 1rem;
    display: inline-block;
    vertical-align: top;
  }
  .mine-coll-goods-div-bottom button{
    float: right;
    width:3.75rem;
    height: 1.40625rem;
    line-height: 1.40625rem;
    border-radius: 0.703125rem;
    color:#EB84AB;
    font-size: 0.75rem;
    text-align: center;
    border: 1px solid #EB84AB;
    padding: 0;
  }
  .mine-collection-status{
    width:2.5rem;
    height: 1.25rem;
    border-radius: 0.625rem;
    color:white;
    font-size: 0.8125rem;
    text-align: center;
    line-height: 1.25rem;
    background-color: #CCCCCC;
  }
  .mine-coll-shadow{
    width:100%;
    height: 6.8125rem;
    background: rgba(0,0,0,0.4);
    position: relative;
    top: -6rem;
  }
  .mine-coll-content{
    width:100%;
  }
  .mine-coll-content button{
    width:4.125rem;
    height:1.875rem;
    color:white;
    border: 1px solid white;
    border-radius: 0.5rem;
    text-align: center;
    line-height: 1.875rem;
    font-size: 0.8125rem;
    padding: 0;
    margin-top: 2.5rem;
    margin-left: 10rem;
  }
  .mine-collection-noData{
    width:100%;
    text-align: center;
    font-size: 1rem;
    color:#333;
    background-color: white;
    padding-top: 3rem;
  }


</style>



// WEBPACK FOOTER //
// src/components/page/mine/mineCollection.vue